import React from 'react';
import HealthSummary from '../../containers/HealthSummary/HealthSummary';

export class HealthSummaryPage extends React.Component {
  render() {
    return <HealthSummary />;
  }
}